import {Injectable}                                        from '@angular/core';
import {HttpEvent, HttpHandler, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of}                                    from 'rxjs';
import {ApUploadFakeStreamService}                         from './ap-upload-fake-stream.service';
import {APP_CONFIGURATION}                                 from '../../ap-core/config';

@Injectable({providedIn: 'root'})
export class ApUploadInterceptorService {

  constructor(private fakeStream: ApUploadFakeStreamService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url === APP_CONFIGURATION.UploadSaveUrl) {
      return this.fakeStream.handler;
    }

    if (req.url === APP_CONFIGURATION.UploadRemoveUrl) {
      return of(new HttpResponse({status: 200}));
    }

    return next.handle(req);
  }
}
